function getMultipleGroup(allocationUsers = []) {
  return allocationUsers.find((item) => item.team === "Multiple");
}

function withoutMultipleGroup(allocationUsers = []) {
  return allocationUsers.filter((item) => item.team !== "Multiple");
}

export function toggleTeamAllocationGroup(
  allocationUsers = [],
  nextGroup
) {
  const isTeamAlreadySelected = allocationUsers.some(
    (item) => item.team === nextGroup.team
  );

  if (isTeamAlreadySelected) {
    return allocationUsers.filter((item) => item.team !== nextGroup.team);
  }

  const multipleGroup = getMultipleGroup(allocationUsers);
  if (multipleGroup) {
    const hasSameTeamUserInMultiple = multipleGroup.users.some(
      (user) => user?.teams?.team_name === nextGroup.team
    );

    if (hasSameTeamUserInMultiple) {
      return [...withoutMultipleGroup(allocationUsers), nextGroup];
    }
  }

  return [...allocationUsers, nextGroup];
}

export function toggleUserAllocationGroup(
  allocationUsers = [],
  nextUser
) {
  const isEntireTeamSelected = allocationUsers.some(
    (item) => item.team === nextUser.teams?.team_name
  );

  if (isEntireTeamSelected) {
    return allocationUsers.filter(
      (item) => item.team !== nextUser.teams?.team_name
    );
  }

  const multipleGroup = getMultipleGroup(allocationUsers);
  if (!multipleGroup) {
    return [
      ...allocationUsers,
      {
        team: "Multiple",
        users: [nextUser],
      },
    ];
  }

  const hasUser = multipleGroup.users.some(
    (user) => user.user_id === nextUser.user_id
  );
  const users = hasUser
    ? multipleGroup.users.filter((user) => user.user_id !== nextUser.user_id)
    : [...multipleGroup.users, nextUser];

  return [
    ...withoutMultipleGroup(allocationUsers),
    {
      team: "Multiple",
      users,
    },
  ];
}
